<template>
    <div id="frontPage">
        <tico-logo></tico-logo>
        <div id="calculators">
            <h2 class="photoOverlay">Calculate Your Emissions Today</h2>
            <ul id="calculatorLinks">
                <li>
                    <router-link id="travelButton" class="calculator-button" to="travel">
                        <!--                        <i class="fas fa-plane calculator-icon"></i>-->
                        <img src="../assets/vectors/Airplane-transparent.svg" alt="Airplane" class="calculator-icon">
                        <span class="calculator-title">Travel Calculator</span>
                        <span class="calculator-desc">Determine and offset your estimated travel emissions</span>
                    </router-link>
                </li>
                <li>
                    <router-link id="generalButton" class="calculator-button" to="living">
                        <!--                        <i class="fas fa-home calculator-icon"></i>-->
                        <img src="../assets/vectors/House-transparent.svg" alt="House" class="calculator-icon">
                        <span class="calculator-title">Lifestyle Emissions Calculator</span>
                        <span class="calculator-desc">Determine and offset your estimated daily emissions</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div id="directPurchasing">
            <h2>If you know the amount of carbon you need to offset, please use our direct purchasing tool.</h2>
            <router-link id="directButton" to="carbon">Purchase Carbon Credits Directly</router-link>
        </div>
        <div id="about"><p>Our carbon footprint is the total amount of greenhouse gases we generate through regular
            activities such as driving, flying, or using electricity. Do you know what your carbon footprint is? Now you
            can find out by using the new TICO2e Carbon Calculator. It’s quick and easy to determine how your travel
            affects the environment and to do your part to help offset the impact.</p>
            <p>Developed by the National Indian Carbon Coalition, the TICO2e calculator generates donations that help
                support tribal carbon mitigation projects, protect the environment, and preserve Indian land for future
                generations.</p>
        </div>
        <div id="carouselWrap" ref="carouselWrap">
            <h2>Learn More About Our Nature-Based Climate Solutions:</h2>
            <vueper-slides
                class="no-shadow"
                :bullets="false"
                bullets-inside
                :visible-slides="3"
                slide-multiple
                :gap="3"
                :slide-ratio="1 / 4"
                fixed-height="250px"
                :dragging-distance="200"
                :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
                style="margin-bottom: 1rem">
                <vueper-slide
                    :style="slide_styles"
                    link="https://fond-du-lac-project-landing-page.getresponsesite.com/"
                    open-in-new>
                    <template #content>
                        <div class="slide-wrap">
                            <img class="slide-photo" src="../assets/photos/FDL-small.jpg"
                                 alt="Fond du Lac Band of Lake Superior Chippewa Carbon Project">
                            <div class="slide-caption">Fond du Lac Band of Lake Superior Chippewa Carbon Project</div>
                        </div>
                    </template>
                </vueper-slide>
                <vueper-slide
                    :style="slide_styles"
                    link="https://blackfeet-nation-project-landing-page.getresponsesite.com/"
                    open-in-new>
                    <template #content>
                        <div class="slide-wrap">
                            <img class="slide-photo" src="../assets/photos/Lookingglass-small.jpg"
                                 alt="Blackfeet Indian Nation Carbon Project">
                            <div class="slide-caption">Blackfeet Indian Nation Carbon Project</div>
                        </div>
                    </template>
                </vueper-slide>
                <vueper-slide
                    :style="slide_styles"
                    link="https://mississippi-band-project-landing-page.getresponsesite.com/"
                    open-in-new>
                    <template #content>
                        <div class="slide-wrap">
                            <img class="slide-photo" src="../assets/photos/Loblolly-Forest-small.jpg"
                                 alt="Mississippi Band of Choctaw Indians Carbon Project">
                            <div class="slide-caption">Mississippi Band of Choctaw Indians Carbon Project</div>
                        </div>
                    </template>
                </vueper-slide>
                <vueper-slide
                    :style="slide_styles"
                    link="https://keweenaw-bay-project-landing-page.getresponsesite.com/"
                    open-in-new>
                    <template #content>
                        <div class="slide-wrap">
                            <img class="slide-photo" src="../assets/photos/Keweenaw-Bay-small.jpg"
                                 alt="Keweenaw Bay Indian Community Forest Carbon Project">
                            <div class="slide-caption">Keweenaw Bay Indian Community Forest Carbon Project</div>
                        </div>
                    </template>
                </vueper-slide>
            </vueper-slides>
        </div>
        <iframe id="youtube" src="https://www.youtube.com/embed/mnfBI1F75Z8?si=PYXXu8JaTSbLYg6n"
                title="YouTube video player"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div id="subscribe">
            <h3>Subscribe to our Quarterly Newsletter:</h3>
            <h3>The Indian Carbon Connection</h3>
            <a id="subscribeLink" href="https://nicc-newsletter-signup.getresponsesite.com/" target="_blank">Sign up
                now</a>
        </div>
    </div>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import TicoLogo from "./shared/tico-logo.vue";

export default {
    name: "Home",
    components: {TicoLogo, VueperSlides, VueperSlide},
    data() {
        return {
            slide_styles: {
                'background-color': "#006A4C",
                color: 'white',
                'mix-blend-mode': 'normal',
                'text-decoration': 'none'
            }
        };
    }
};
</script>

<style scoped lang="less">
@import (reference) "../assets/variables";


.photoOverlay {
    background: @light-green;
    font-size: 2rem;
    font-weight: 700;
    color: @green;
    padding: 0.5rem;
    margin: 0;
}

#calculators {
    background: url("../assets/photos/DJI-small.jpg") no-repeat;
    background-size: cover;
    padding: 2rem;
    border-radius: 2rem;
}

#calculatorLinks {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    li {
        background: @green;
        margin: 1.5rem 0 0;
        padding: 1rem 1rem 2rem;
        border-radius: 2rem;
        width: 30%;

        .calculator-button {
            color: @light-green;
            text-decoration: none;
        }

        //i.calculator-icon {
        //    display: block;
        //    font-size: 7rem;
        //    margin: 0.5rem;
        //}
        .calculator-icon {
            display: block;
            max-width: 60%;
            height: auto;
            margin: 0.5rem auto;
        }

        .calculator-title {
            font-weight: bold;
            display: block;
            font-size: 1.1rem;
            height: 3rem;
        }
    }
}

#directPurchasing {
    border-bottom: 3px solid @light-gray;
    padding: 0 0 3rem;

    h2 {
        font-size: 1.6rem;
        color: @green;
        margin: 2rem 0;
        line-height: 1.5;
    }

    #directButton {
        background: @green;
        color: @light-green;
        border-radius: 1rem;
        padding: 1rem;
        font-size: 1.5rem;
        text-decoration: none;
        font-family: "Archivo", sans-serif;
        font-weight: 700;
    }
}

#about {
    text-align: left;
    font-size: 1.25rem;
    font-family: "Archivo", sans-serif;
    color: @green;
    line-height: 1.5;
}

.button {
    width: 22em;
}

img.nicc-icon {
    height: 1em;
}

#carouselWrap {
    background: @light-green;
    width: 100%;
    box-sizing: border-box;
    padding: 1rem 3rem 1rem;
    color: @green;
    mix-blend-mode: multiply;

    h2 {
        font-size: 2rem;
        margin: 0 0 1rem;
    }
}

.slide-wrap {
    width: 100%;
    height: 100%;
    padding: 0 0 1rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.slide-photo {
    width: 100%;
    height: auto;
}

.slide-caption {
    padding: 0 0.5rem;
}

#youtube {
    width: 100%;
    box-sizing: border-box;
    max-width: 100vw;
    height: auto;
    aspect-ratio: 16 / 9;
}

#subscribe {
    background: url("../assets/photos/_DSC1536-2-small.jpg") no-repeat @green;
    aspect-ratio: 74/25;
    box-sizing: border-box;
    background-size: contain;
    padding: 1rem 0.5rem 1rem calc(50% + 0.5rem);
    color: white;

    h3 {
        margin: 0;
        line-height: 1.5;
    }

    #subscribeLink {
        display: block;
        background: white;
        border-radius: 1rem;
        padding: 0.25rem 0.5rem;
        margin: 1rem;
        text-transform: uppercase;
        text-decoration: none;
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);

        &:link, &:visited {
            color: @green;
        }

        &:hover {
            background: @light-green;
        }

        &:active {
            position: relative;
            top: 5px;
            box-shadow: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue